import { render, staticRenderFns } from "./AlertUserSelector.vue?vue&type=template&id=309780ce&scoped=true"
import script from "./AlertUserSelector.vue?vue&type=script&lang=js"
export * from "./AlertUserSelector.vue?vue&type=script&lang=js"
import style0 from "./AlertUserSelector.vue?vue&type=style&index=0&id=309780ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309780ce",
  null
  
)

export default component.exports